export const DATA_PROVIDE_STATUS_NAME = {
  UNIDENTIFIED: '관리자 데이터 이용 요청',
  APPROVAL: '데이터 제공 승인',
  REJECT: '데이터 제공 거절',
  UNAVAILABLE: '데이터 제공 불가',
  WITHDRAWAL: '데이터 제공 철회',
  REQUEST_MALL: '관리자 필수 판매몰 변경',
};
